// src/components/Pricing.jsx
import Reveal from "./Reveal";

const plans = [
  {
    name: "Básico",
    price: 4990,
    description: "",
    features: [
      "Hasta 5 Geocercas",
      "Alertas",
      "Estadisticas basicas",
      "100 MB almacenamiento",
      "Corta corriente",
      "Costo de instalación $39.990",
    ],
    whatsappUrl:
      "https://api.whatsapp.com/send?phone=56968585106&text=Hola,%20quiero%20cotizar%20el%20plan%20basico",
  },
  {
    name: "Pro",
    price: 8990,
    description: "",
    features: [
      "Hasta 70 Geocercas",
      "Alertas",
      "Notificaciones Ampliadas",
      "Estadisticas Completas",
      "Aviso de mantenciones KM",
      "200 MB almacenamiento",
      "Corta corriente",
      "Costo de instalación $24.990",
    ],
    whatsappUrl:
      "https://api.whatsapp.com/send?phone=56968585106&text=Hola,%20quiero%20cotizar%20el%20plan%20pro",
  },
];


// formateador CLP
const formatCLP = (n) =>
  new Intl.NumberFormat("es-CL", {
    style: "currency",
    currency: "CLP",
    maximumFractionDigits: 0,
  }).format(n);

function Check() {
  return (
    <svg
      viewBox="0 0 20 20"
      className="mt-1 h-5 w-5 flex-none text-[#8BB2FF]"
      fill="currentColor"
    >
      <path
        fillRule="evenodd"
        d="M16.704 5.29a1 1 0 010 1.414l-7.2 7.2a1 1 0 01-1.414 0l-3-3a1 1 0 011.414-1.414l2.293 2.293 6.493-6.493a1 1 0 011.414 0z"
        clipRule="evenodd"
      />
    </svg>
  );
}

function PlanCard({ plan }) {
  return (
    <div
      className="
        w-full sm:w-[340px] md:w-[380px]
        rounded-3xl border border-white/10 bg-zentra-surface/80
        p-6 md:p-7 shadow-[0_20px_50px_rgba(2,8,23,0.6)] backdrop-blur
      "
    >
      <p className="text-sm font-medium text-[#8BB2FF]">{plan.name}</p>

      <div className="mt-2 flex items-baseline gap-2">
        <span className="text-4xl md:text-5xl font-bold text-white">
          {formatCLP(plan.price)}
        </span>
        <span className="text-base text-slate-400">/al mes</span>
      </div>

      <p className="mt-4 text-slate-300">{plan.description}</p>

      <ul className="mt-6 space-y-3">
        {plan.features.map((f) => (
          <li key={f} className="flex items-start gap-3">
            <Check />
            <span className="text-slate-300">{f}</span>
          </li>
        ))}
      </ul>

     <a
  href={plan.whatsappUrl} 
  target="_blank"
  rel="noopener noreferrer"
  className="
    mt-8 inline-flex w-full items-center justify-center
    rounded-2xl px-5 py-3.5 text-[15px] font-semibold tracking-tight
    text-white
    bg-gradient-to-r from-[var(--brand-1)] via-[var(--brand-3)] to-[var(--brand-4)]
    shadow-[0_18px_45px_rgba(0,0,0,0.65)]
    hover:shadow-[0_26px_70px_rgba(0,0,0,0.85)]
    hover:brightness-110
    focus:outline-none focus:ring-2 focus:ring-[var(--brand-3)] focus:ring-offset-2 focus:ring-offset-slate-900
    transition-all duration-200
  "
>
  Ver Factibilidad
</a>
    </div>
  );
}

export default function Pricing() {
  return (
    <section id="pricing" className="relative isolate overflow-hidden">
    
      <div className="absolute inset-0 -z-10">
        <img
          src="/img/phone.png"
          alt=""
          className="
            h-full w-full object-cover
            object-[85%_50%] md:object-[60%_50%]
          "
        />
       
        <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/50 to-transparent" />
     
        <div className="absolute inset-x-0 bottom-0 h-1/2 bg-gradient-to-t from-black/50 to-transparent" />
      </div>

      <div className="mx-auto max-w-6xl px-4 py-20">
        <Reveal>
          <div className="inline-flex items-center gap-2 rounded-full border border-[rgba(255, 255, 255, 0.08)] bg-white px-3 py-1 text-[12px] text-[#204B97]">
            Zentra GPS
            <span className="inline-block h-1.5 w-1.5 rounded-full bg-[#36C0B9]" />
          </div>
          <h2 className="heading-display mt-2 text-4xl md:text-5xl font-bold text-white">
            Escoge el plan perfecto para ti
          </h2>
          
        </Reveal>

       
        <div className="mt-10 flex flex-col gap-6 md:flex-row md:justify-between">
          <Reveal>
            <PlanCard plan={plans[0]} /> 
          </Reveal>

          <Reveal delay={0.05}>
            <PlanCard plan={plans[1]} /> 
          </Reveal>
        </div>
      </div>
    </section>
  );
}
